import { render } from "./VueSEO.vue?vue&type=template&id=b0e3199a"
const script = {}

import exportComponent from "C:\\Users\\xmaop\\proyectos\\vue-seo-friendly-spa-template\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__